import { Component, computed, inject } from '@angular/core';
import { currentTenantId, currentUser, isInternalTenant } from '@/utils/admin-utils';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TenantRoleService } from '@artemis-software/wr-api/api/tenantRole.service';
import { TenantRoleFilterDto } from '@artemis-software/wr-api/model/tenantRoleFilterDto';
import { TenantRoleItemDto } from '@artemis-software/wr-api/model/tenantRoleItemDto';
import { CurrentUserService } from '@services/current-user.service';

@Component({
  standalone: false,
  selector: 'wr-role-overview-page',
  templateUrl: './tenant-role-overview-page.component.html',
  styleUrls: ['./tenant-role-overview-page.component.scss']
})
export class TenantRoleOverviewPageComponent {
  currentUserService = inject(CurrentUserService);
  tenantId = currentTenantId();
  canCreate = computed(() => this.currentUserService.hasPrivilege('canCreateTenantRoles'));

  readonly loadUsers = (filter: TenantRoleFilterDto) => this.tenantRoleService.findAll({ ...filter, tenantId: this.tenantId() });
  readonly getCount = (filter: TenantRoleFilterDto) => this.tenantRoleService.getCount({ ...filter, tenantId: this.tenantId() });

  form!: FormGroup;

  constructor(private readonly router: Router,
              private readonly formBuilder: FormBuilder,
              private readonly tenantRoleService: TenantRoleService) {
    this.form = this.formBuilder.group({
      text: this.formBuilder.control(''),
    });
  }

  navigateToTenantRole(tenantRole: TenantRoleItemDto): void {
    this.router.navigate(['tenantRole', tenantRole.id]);
  }

  add(): void {
    this.router.navigate(['tenantRole', 'new']);
  }
}
